module.exports = __webpack_public_path__ + "img/01.d2574949.png";